import { CustomBaseUrl } from "./RequestOptions";

export function getCustomBaseUrl(): CustomBaseUrl {
    return CustomBaseUrl.PublishedCalendar;
}
